// ---- helpers ----
const getByPath = (obj, path) =>
  (path || "").split(".").reduce((acc, k) => (acc == null ? acc : acc[k]), obj);

const fmt = {
  text: (v, key) => {
    if (v == null || v === "") return "--";
    if (key === "duration_seconds" && Number.isFinite(Number(v))) {
      return `${Number(v).toFixed(0)} s`;
    }
    if (key === "rtv_score") {
      // keep simple; show raw if negative/unavailable
      const n = Number(v);
      if (!Number.isFinite(n) || n < 0) return "--";
      if (n >= 0.7) return "Good";
      if (n >= 0.4) return "Fair";
      return "Poor";
    }
    return String(v);
  },
  L: (v) =>
    Number.isFinite(Number(v)) ? Math.abs(Number(v)).toFixed(2) : "--",
  ratio: (v) => {
    const n = Number(v);
    if (!Number.isFinite(n)) return "--";
    if (n > 0 && n < 1) {
      const s = n.toFixed(2);
      return s.startsWith("0") ? s.slice(1) : s; // ".79"
    }
    return n.toFixed(2);
  },
  bpm: (v) =>
    Number.isFinite(Number(v)) ? `${Number(v).toFixed(0)} breaths/min` : "--",
  date: (v) => {
    if (!v) return "--";
    const d = typeof v === "number" ? new Date(v) : new Date(String(v));
    if (isNaN(d.getTime())) return "--";
    return `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(
      2,
      "0",
    )}-${String(d.getUTCDate()).padStart(2, "0")} ${String(
      d.getUTCHours(),
    ).padStart(2, "0")}:${String(d.getUTCMinutes()).padStart(2, "0")} UTC`;
  },
  range: (v) =>
    Array.isArray(v) && v.length === 2 ? `${v[0]}–${v[1]} yrs` : "--",
};

const toneFor = (label, value) => {
  if (label === "Signal quality") {
    if (value === "Good") return "text-green-600";
    if (value === "Fair") return "text-amber-600";
    if (value === "Poor") return "text-red-600";
  }
  return "";
};

export { getByPath, fmt, toneFor };
